import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', background: 'var(--bg)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'var(--font)', padding: 24,
      }}>
        <div style={{
          maxWidth: 440, width: '100%', textAlign: 'center',
          background: 'var(--surface)',
          border: '0.5px solid var(--border2)',
          borderRadius: 20, padding: '40px 32px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: 'var(--text)', margin: '0 0 10px', letterSpacing: '-0.01em' }}>
            Something went wrong
          </h2>
          <p style={{ fontSize: 13.5, color: 'var(--muted)', lineHeight: 1.7, margin: '0 0 24px' }}>
            An unexpected error occurred. Your data is safe — try refreshing the page.
          </p>
          {this.state.error && (
            <div style={{
              fontSize: 11, color: 'var(--dim)', fontFamily: 'monospace',
              background: 'var(--bg)', border: '0.5px solid var(--border)',
              borderRadius: 8, padding: '10px 14px', marginBottom: 20,
              textAlign: 'left', lineHeight: 1.6, wordBreak: 'break-all',
              maxHeight: 80, overflow: 'hidden',
            }}>
              {this.state.error.message}
            </div>
          )}
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                flex: 1, background: '#7f77dd', color: '#fff', border: 'none',
                borderRadius: 10, padding: '12px',
                fontFamily: 'var(--font)', fontSize: 14, fontWeight: 600,
                cursor: 'pointer', boxShadow: '0 4px 14px rgba(127,119,221,0.3)',
              }}
            >
              Reload page
            </button>
            <button
              onClick={() => { window.location.href = '/app'; }}
              style={{
                flex: 1, background: 'none', color: 'var(--muted)',
                border: '0.5px solid var(--border2)',
                borderRadius: 10, padding: '12px',
                fontFamily: 'var(--font)', fontSize: 14, cursor: 'pointer',
              }}
            >
              Go to app
            </button>
          </div>
        </div>
      </div>
    );
  }
}
